import useTranslations from "hooks/useTranslations"

interface StatProps {
  percentage: string
  description: string
  extra?: string
}

const Stat = ({ percentage, description, extra }: StatProps) => (
  <div className="space-y-3 border-l border-kkm-green pl-2">
    <div className=" relative flex">
      <div className="font-display text-5xl font-bold text-kkm-darkgreen lg:text-6xl">
        {percentage}
      </div>
      <div className="">
        <div className="leading-0 absolute ml-0.5 text-sm font-bold">
          <span>%</span>
        </div>
        {extra && (
          <div className="absolute bottom-0 mt-4 font-display text-3xl font-bold text-kkm-green">
            {extra}
          </div>
        )}
      </div>
    </div>
    <p className="text-base leading-relaxed text-zinc-700">{description}</p>
  </div>
)

export default function WhyUs() {
  const {
    whyUsTitle,
    whyUsText,
    whyUsStat1Percentage,
    whyUsStat1Description,
    whyUsStat2Percentage,
    whyUsStat2Description,
    whyUsStat3Percentage,
    whyUsStat3Description,
    whyUsStat4Percentage,
    whyUsStat4Description,
    whyUsSources,
  } = useTranslations()

  const stats = [
    {
      percentage: whyUsStat1Percentage,
      description: whyUsStat1Description,
    },
    {
      percentage: whyUsStat2Percentage,
      description: whyUsStat2Description,
    },
    {
      percentage: whyUsStat3Percentage,
      description: whyUsStat3Description,
    },
    {
      percentage: whyUsStat4Percentage,
      description: whyUsStat4Description,
    },
  ]

  return (
    <div className="bg-white py-16 lg:py-24">
      <div className="mx-auto max-w-7xl space-y-12 px-4 sm:px-6 lg:px-8">
        {/* Title */}
        <h2 className="m-0 max-w-4xl text-3xl font-extrabold tracking-tight text-zinc-800 md:text-4xl lg:text-5xl">
          {whyUsTitle}
        </h2>

        {/* Main text */}
        <div className="max-w-4xl">
          <p className="text-lg leading-relaxed text-zinc-700 lg:text-xl">
            {whyUsText}
          </p>
        </div>

        {/* Stats grid */}
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {stats.map((stat) => (
            <Stat
              key={stat.percentage}
              percentage={stat.percentage}
              description={stat.description}
            />
          ))}
        </div>

        {/* Sources */}
        <div className="">
          <p className="text-sm italic text-zinc-600">{whyUsSources}</p>
        </div>
      </div>
    </div>
  )
}
